module.exports = __webpack_public_path__ + "assets/img/year-main-content-bg.879845aa.png";